import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

/**
 * Import reducers
 */
import wgw from './wgw';
import zone from './zone';
import alert from './alert';
import config from './config';
import plugin from './plugin';
import calendar from './calendar';
import education from './education';
import recycleRight from './recycleRight';
import quiz from './quiz';
import wwtk from '../../pages/Resources/redux/reducers';
import help from '../../pages/HelpScreens/redux/reducers';
import bulkPickup from '../../pages/BulkPickup/redux/reducers';
import campaign from '../../pages/Campaign/redux/reducers';
import getPluginId from '../../helpers/getPluginId';

const rootReducer = combineReducers({
  wgw, // What goes where data
  zone, // Zone setup
  alert, // Control Alert Modal Box
  plugin, // Application main data
  config: persistReducer({
    key: `config-${getPluginId()}`,
    whitelist: ['districtId', 'localityId', 'selectedLang'],
    storage
  }, config), // Application configs like lang
  calendar,
  campaign, // Application campaign stuff
  wwtk,
  help,
  education,
  recycleRight,
  quiz,
  bulkPickup
});

export default rootReducer;
